import { useRef, useEffect, useState } from "react";
import "./UwPolicyCharges.scss";
import { useSelector } from "react-redux";
import { forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from "react-router-dom";

import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TablePagination,
} from "@mui/material";
import { motion } from "framer-motion";
import { GridLoader, ScaleLoader } from "react-spinners";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import numeral from "numeral";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch";
import { formatNumber, formatStringToNumberV2, logData } from "../../../utils/genericFunctions";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import { MdAdd, MdClose, MdDelete } from "react-icons/md";
import { showToast } from "../../../toastService";


const UwPolicyCharges = forwardRef(({ policyDocid, riskNoteNo, chargeLevel, endIndex, riskDocid, plCurCode, productCode, endorsementCode, documentEnabled, profileLimitValues }, ref) => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const [isAddChargeOpen, setIsAddChargeOpen] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        action_invoked: "",
    });
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [policyCharges, setPolicyCharges] = useState([]);

    const [productCharges, setProductCharges] = useState([]);
    const [selectedCharge, setSelectedCharge] = useState(null);
    const [totalFc, setTotalFc] = useState(0);
    const [totalLc, setTotalLc] = useState(0);
    const [chargeBasis, setChargeBasis] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    // console.log(`in charges`);
    // console.log(`policyDocid ... ${policyDocid}`);
    // console.log(`riskNoteNo ... ${riskNoteNo}`);
    // console.log(`chargeLevel ... ${chargeLevel}`);
    // console.log(`endIndex ... ${endIndex}`);
    // console.log(`riskDocid ... ${riskDocid}`);

    // Function to get limit_yn value by limit_code
    const getLimitValue = (limitCode) => {
        try {
            const limit = profileLimitValues.find(l => l.limit_code === limitCode);
            return limit ? limit.limit_yn : null;
        } catch (error) {
            console.log(error)
        }
    };


    const fetchPolicyCharges = async () => {
        try {
            setIsLoading(true);
            const res = await newRequest.post("/uwPolicyCharge/findAll/",
                {
                    policy_docid: policyDocid,
                    charge_level: chargeLevel,
                    charge_level_docid: chargeLevel === "Policy" ? policyDocid : riskDocid
                });
            setPolicyCharges(res.data);
            // set charge basis
            const options = ["Sum Insured", "Net Premium", "Gross Premium", "Fixed Amount", "Other Charge"]?.map((code) => ({
                value: code,
                label: code,
            }));
            setChargeBasis(options);
        } catch (error) {
            console.error("Error fetching excess types:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchProductCharges = async () => {
        try {
            const res = await newRequest.post("/uwProductEndCharge/findAll/", {
                ac_pr_code: productCode,
                ac_end_code: endorsementCode,
                ac_mandatory: "N"
            });
            const options = res?.data?.map((code) => ({
                charge_type: code?.ac_charge_type,
                charge_basis: code?.ac_charge_basis,
                charge_rate: code?.ac_charge_rate,
                charge_rate_per: code?.ac_charge_rate_per,
                value: code?.ac_charge_code,
                label: code?.ac_charge_name,
            }));
            // console.log(`setProductCharges  ${JSON.stringify(options, null, 2)}`);
            setProductCharges(options);
        } catch (error) {
            console.error("Error fetching charges:", error);
        }
    };


    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const slicedCharges = policyCharges?.slice(
        currentPage * rowsPerPage,
        currentPage * rowsPerPage + rowsPerPage
    );

    const handleRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 5));
        setCurrentPage(0);
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "deleteNumGen") {

            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };

    const handleCloseNotifyDialog = () => {
        setIsNotifyDialogOpen(false);
    };


    const handleChargeChange = (e, rowId, field) => {
        try {
            const newSmiData = [...policyCharges];
            const index = newSmiData.findIndex(smi => smi._id === rowId);
            if (index !== -1) {
                if (e && e.target) {
                    // Regular input
                    newSmiData[index][field] = e.target.value;
                } else if (e && typeof e === "object" && e.value !== undefined) {
                    // react-select returns the whole selected option object
                    newSmiData[index][field] = e.value;
                } else {
                    // ToggleSwitch (or direct value like "Y"/"N")
                    newSmiData[index][field] = e;
                }
                setPolicyCharges(newSmiData);
            }
        } catch (error) {
            console.log(error);
        }
    };


    const handleChargeBlur = async (rowId, field) => {
        try {
            const updatedData = [...policyCharges];
            const index = updatedData.findIndex(smi => smi._id === rowId);
            if (index !== -1) {
                const value = updatedData[index][field];
                let formattedValue = null;

                if (field === "charge_rate") {
                    formattedValue = parseFloat(formatNumber(formatStringToNumberV2(value), 4)) || 0;
                } else {
                    formattedValue = value;
                }
                updatedData[index][field] = formattedValue;
                updatedData[index]["changed_xx"] = "Y";
                logData(`updating ... ${rowId}`, { [field]: formattedValue });
                await newRequest.put(`/uwPolicyCharge/upd/${rowId}`, { [field]: formattedValue });
                setPolicyCharges(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useImperativeHandle(ref, () => ({
        saveChargesFromParent
    }));

    const saveChargesFromParent = async () => {
        try {
            saveCharges();
        } catch (error) {
            console.log(error)
        }
    }


    const saveCharges = async () => {
        try {
            for (let index = 0; index < policyCharges.length; index++) {
                const singleRecord = policyCharges[index];
                await newRequest.put(
                    `/uwPolicyCharge/upd/${singleRecord?._id}`,
                    {
                        ...singleRecord,
                        charge_rate: parseFloat(formatStringToNumberV2(singleRecord?.charge_rate)) || 0,
                        charge_rate_per: parseFloat(formatStringToNumberV2(singleRecord?.charge_rate_per)) || 0,
                    }
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    // calculate total fees
    useEffect(() => {
        const totalFc = policyCharges?.reduce((sum, item) => { return sum + parseFloat(item?.charge_fc_amount); }, 0);
        const totalLc = policyCharges?.reduce((sum, item) => { return sum + parseFloat(item?.charge_lc_amount); }, 0);
        setTotalFc(totalFc);
        setTotalLc(totalFc);
    }, [policyCharges]);

    useEffect(() => {
        try {
            setIsLoading(true);
            fetchPolicyCharges();
            fetchProductCharges();
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }, [policyDocid, riskDocid]);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
            className="uw-policy-charges">
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <div className="uw-policy-charges-wrapper">
                    {/* <span>{`documentEnabled ${documentEnabled}`}</span>
                    <span>{`UW1028 ${getLimitValue("UW1028")}`}</span>
                    <span>{`UW1029 ${getLimitValue("UW1029")}`}</span>
                    <span>{`UW1030 ${getLimitValue("UW1030")}`}</span> */}
                    <div className="table-content">
                        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                            <Table sx={{ width: "max-content", border: 'none' }}>
                                <TableHead className="tablehead">
                                    <TableRow className="tablerow">
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            #
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                                <span>{t('charge').toUpperCase()}</span>
                                                {documentEnabled === "Y" &&
                                                    getLimitValue("UW1029") === "Y" &&
                                                    <CircularButton
                                                        currentTheme={currentTheme}
                                                        onClick={async (e) => setIsAddChargeOpen(true)}
                                                        icon={<MdAdd />}
                                                        width={"30px"}
                                                        height={"30px"} />}
                                            </div>
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                            {t('basis').toUpperCase()}
                                        </TableCell>
                                        <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                            {t('rate').toUpperCase()}
                                        </TableCell>
                                        {getLimitValue("UW1028") === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                {t('override').toUpperCase()}
                                            </TableCell>}
                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                            {`${t('amount').toUpperCase()} [${plCurCode}]`}
                                        </TableCell>
                                        {documentEnabled === "Y" && getLimitValue("UW1030") === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                {t('action').toUpperCase()}
                                            </TableCell>}
                                    </TableRow>
                                </TableHead>
                                {policyCharges?.length > 0 &&
                                    <TableBody className="tablebody">
                                        {slicedCharges?.map((row, index) => (
                                            <TableRow
                                                key={row._id}
                                                className={`${selectedCharge?._id === row._id ? "tablerow current" : "tablerow"}`}
                                                onClick={() => setSelectedCharge(row)}
                                            >
                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                    <span>{index + 1}</span>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                        <span className="sub-title">{row?.charge_name}</span>
                                                        <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.charge_code}</span>
                                                    </div>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                    {documentEnabled === "Y" &&
                                                        row?.charge_override === "Y" ?
                                                        <Select
                                                            id={`charge_basis_${row?._id}`}
                                                            name={`charge_basis_${row?._id}`}
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="140px"
                                                            height="36px"
                                                            options={chargeBasis}
                                                            isSearchable={true}
                                                            placeholder={t('basis')}
                                                            value={chargeBasis.find(option => option.value === row?.charge_basis) || null}
                                                            onChange={(selectedOption) => handleChargeChange(selectedOption, row?._id, 'charge_basis')}
                                                            onBlur={() => handleChargeBlur(row?._id, "charge_basis")}
                                                        /> :
                                                        <span className="sub-title">{row?.charge_basis}</span>}
                                                </TableCell>
                                                <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                                    {documentEnabled === "Y" &&
                                                        row?.charge_override === "Y" ?
                                                        <div className="input-item-with-label">
                                                            <input
                                                                id="charge_rate"
                                                                name="charge_rate"
                                                                type="text"
                                                                value={row?.charge_rate}
                                                                onChange={(e) => handleChargeChange(e, row?._id, 'charge_rate')}
                                                                onBlur={() => handleChargeBlur(row?._id, "charge_rate")}
                                                                style={{ width: "100%", textAlign: "right" }}
                                                                className="form-input-item table"
                                                            />
                                                        </div>
                                                        :
                                                        <span>{numeral(row.charge_rate).format("0,0.00")}</span>}
                                                </TableCell>
                                                {getLimitValue("UW1028") === "Y" &&
                                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                        <ToggleSwitch
                                                            value={row?.charge_override}
                                                            onChange={(val) => handleChargeChange(val, row._id, "charge_override")}
                                                            label={""}
                                                            labelPosition="end"
                                                            labelWidth="max-content"
                                                            border="N"
                                                            disabled={documentEnabled !== "Y"}
                                                            onBlur={() => handleChargeBlur(row?._id, "charge_override")}
                                                        />
                                                    </TableCell>}
                                                <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                    <span>{numeral(row?.charge_lc_amount).format("0,0.00")}</span>
                                                </TableCell>
                                                {documentEnabled === "Y" && getLimitValue("UW1030") === "Y" &&
                                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                        <CircularButton
                                                            currentTheme={currentTheme}
                                                            color="#D32F2F"
                                                            onClick={async (e) => {
                                                                try {
                                                                    const res = await newRequest.delete(`/uwPolicyCharge/del/${row?._id}`);
                                                                    if (res.data?.msg === "deleted") {
                                                                        setPolicyCharges((prevData) => prevData.filter(doc => doc?._id !== row?._id));
                                                                        showToast(t('deleted'), "success");
                                                                    } else {
                                                                        showToast("Error deleting charge!", "error");
                                                                    }
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            icon={<MdDelete />}
                                                            width={"30px"}
                                                            height={"30px"} />
                                                    </TableCell>}
                                            </TableRow>
                                        ))}
                                    </TableBody>}
                            </Table>
                            {policyCharges?.length > rowsPerPage &&
                                <TablePagination
                                    rowsPerPageOptions={[10]}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleRowsPerPage}
                                    component="div"
                                    count={policyCharges?.length}
                                    rows={policyCharges}
                                    page={currentPage}
                                    onPageChange={handlePageChange}
                                />}
                        </TableContainer>
                    </div>
                    {/* End of charges table */}
                </div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={handleCloseNotifyDialog}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t('confirmation')}
                dialogContent={<p>{objectToAction.action_text}</p>}
            />

            {isAddChargeOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <span className="main-title">  {t('addCharge')} </span>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => setIsAddChargeOpen(false)}
                                icon={<MdClose />}
                                width={"35px"}
                                height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="selectedCharge"
                                    className="form-dropdown-label"
                                    style={{
                                        width: "100px",
                                    }}
                                >
                                    {t('charge').toUpperCase()}
                                </label>
                                <Select
                                    id="selectedCharge"
                                    name="selectedCharge"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    width="300px"
                                    value={selectedCharge}
                                    onChange={(selectedOption) => setSelectedCharge(selectedOption)}
                                    options={productCharges}
                                    isSearchable={true}
                                    placeholder={t('select').toUpperCase()}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                endIcon={<MdAdd />}
                                onClick={async () => {
                                    try {
                                        if (!selectedCharge?.value) {
                                            setNotifyDialogTitle("Note!");
                                            setNotifyDialogText(`Please select charge!`);
                                            setIsNotifyDialogOpen(true);
                                            return;
                                        }
                                        // logData("selectedCharge", selectedCharge);
                                        const res = await newRequest.post("/uwPolicyCharge/add",
                                            {
                                                charge_risk_note_no: riskNoteNo,
                                                charge_policy_docid: policyDocid,
                                                charge_type: selectedCharge.charge_type,
                                                charge_basis: selectedCharge.charge_basis,
                                                charge_level: chargeLevel,
                                                charge_level_docid: chargeLevel === "Policy" ? policyDocid : riskDocid,
                                                charge_code: selectedCharge?.value,
                                                charge_name: selectedCharge?.label,
                                                charge_rate: selectedCharge?.charge_rate || 0,
                                                charge_rate_per: selectedCharge?.charge_rate_per || 100,
                                                charge_fc_amount: 0,
                                                charge_lc_amount: 0,
                                                charge_fc_tax: 0,
                                                charge_lc_tax: 0,
                                                charge_override: "Y",
                                                charge_end_index: endIndex
                                            });
                                        // logData("added charge", res.data);
                                        if (res.data?.msg === "added") {
                                            setPolicyCharges((prev) => [...prev, res.data?.doc]);
                                            setIsAddChargeOpen(false);
                                            showToast(t('added'), "success");
                                        } else if (res.data?.msg === "exists") {
                                            showToast(`${selectedCharge?.label} already exists`, "error");
                                        } else {
                                            showToast("Error adding category!", "error");
                                        }
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                            >
                                {t('add')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}
        </motion.div>
    )
});

export default UwPolicyCharges;